

















































import { Component, Vue, Watch, Provide } from 'vue-property-decorator';
import { ticketClient } from "@/api/index";
import { GetTicketItemListReq, SaveTicketItemsReq, DelTicketItemReq, TicketItem, GetTicketCaseNameListReq } from "@/pbjs/external/ticket/ticket_pb";
import { setCommon, errorMsg, setPage } from "@/utils/request";

@Component({
    name: 'CombinationProperty'
})
export default class CombinationProperty extends Vue {
    @Provide() private resultData: any = [];
    @Provide() private token: any = "";
    @Provide() private ruleForm:any = {"1": {name: "qq"}};
    @Provide() private installmentForm:any = {"1": {name: "qq"}};
    @Provide() private activeName:number = 0;
    @Provide() private period:any = [];
    @Provide() private installmentPeriod:any = [{name: "",start: null, end: null}];
    @Provide() private caseNameOptions: any = [];
    @Provide() private issaveTicketItemsDone: boolean = false;

    private created() {
        this.token = localStorage.getItem("token");
        this.getTicketItemList();
        this.getTicketCaseNameList();
    }

    private addLevel() {
        if (this.activeName == 0) {
            if (this.period.length !== 0) {
                let lastItemEnd: number | null = this.period[this.period.length - 1].end;
                let start: number | null = lastItemEnd && (Number(lastItemEnd) + 1);
                this.period.push({name: "", start: start, end: null});
            } else {
                this.period.push({name: "", start: null, end: null});
            }
        } else if (this.activeName == 1) {
            this.installmentPeriod.push({name: "", start: null, end: null});
        }
    }

    private inputValueChange(index: number, end: number) {
        if (this.period.length != index + 1) {
            this.period[++index].start = Number(end) + 1;
        }
    }

    private deleteCaseItem(index: number) {
        this.period.splice(index, 1);
    }

    private getTicketItemList() {
        let request:any = new GetTicketItemListReq();
        request.setCommonin(setCommon());
        request.setIsstage(Number(this.activeName));
        ticketClient.getTicketItemList(request, {}, (err: any, response:any) => {
            if(response) {
                let data:any = response.toObject();
                if (!data.commonout || (data.commonout.code == 0)) {
                    this.period = [];
                    if (data.listList) {
                        data.listList.forEach((item: any) => {
                            this.period.push({id: item.id, name: item.casename, start: item.startday, end: null});
                        })
                    }
                    this.period.forEach((item: any, index: number) => {
                        if ( index > 0) {
                            this.period[index - 1].end = this.period[index].start - 1;
                        }
                    });
                } else {
                    this.$message.error(data.commonout.errmsg);
                }
            }
            if (err) {
       errorMsg(err);
      }
        });
    }

    private getTicketCaseNameList() {
        let request:any = new GetTicketCaseNameListReq();
        request.setCommonin(setCommon());
        request.setIsstage(Number(this.activeName));
        ticketClient.getTicketCaseNameList(request, {}, (err: any, response:any) => {
            if(response) {
                let data:any = response.toObject();
                if (!data.commonout || (data.commonout.code == 0)) {
                    this.caseNameOptions = data.listList;
                } else {
                    this.$message.error(data.commonout.errmsg);
                }
            }
            if (err) {
       errorMsg(err);
      }
        });
    }

    private saveTicketItems() {
        this.issaveTicketItemsDone = true;
        let request:any = new SaveTicketItemsReq();
        let ticketItemList: any = [];
        this.period.forEach((item: any) => {
            let ticketItem = new TicketItem();
            ticketItem.setCasename(item.name);
            ticketItem.setStartday(Number(item.start));
            ticketItemList.push(ticketItem);
        });
        request.setCommonin(setCommon());
        request.setIsstage(Number(this.activeName));
        request.setListList(ticketItemList);
        ticketClient.saveTicketItems(request, {}, (err: any, response:any) => {
            if(response) {
                let data:any = response.toObject();
                if (!data.commonout || (data.commonout.code == 0)) {
                    this.$message({
                        type: 'success',
                        message: 'submit successfully!'
                    });
                } else {
                    this.$message.error(data.commonout.errmsg);
                }
            }
            if (err) {
                errorMsg(err);
            }
            this.issaveTicketItemsDone = false;
        });
    }
}
